//基準点の準備
const elemTop = [];

//現在地を取得するための設定を関数でまとめる
function PositionCheck() {
  //headerの高さを取得
  const headerH = $("#js_scrollpointNav").outerHeight(true);
  //.js_scrollPointというクラス名がついたエリアの位置を取得する設定
  $(".js_scrollPoint").each(function (i) {//.js_scrollPointクラスがついたエリアからトップまでの距離を計算して設定
    elemTop[i] = Math.round(parseInt($(this).offset().top - headerH));//追従するheader分の高さ（70px）を引き小数点を四捨五入
  });
}

//ナビゲーションに現在地のクラスをつけるための設定
function ScrollAnime() {//スクロールした際のナビゲーションの関数にまとめる
  const scroll = Math.round($(window).scrollTop());
  const NavElem = $("#js_scrollpointNavbox li");//ナビゲーションのliの何番目かを定義するための準備
  $("#js_scrollpointNavbox li").removeClass('is_current');//全てのナビゲーションの現在地クラスを除去
  if (scroll >= 0 && scroll < elemTop[1]) {//スクロール値が0以上 .js_scrollPoint 1つめ（area-1）の高さ未満
    $(NavElem[0]).addClass('is_current');//1つめのliに現在地クラスを付与
  }
  else if (scroll >= elemTop[1] && scroll < elemTop[2]) {//.js_scrollPoint 1つめ（area-1）以上.js_scrollPoint 2つめ（area-2）未満
    $(NavElem[1]).addClass('is_current');//2つめのliに現在地クラスを付与
  }
  else if (scroll >= elemTop[2] && scroll < elemTop[3]) {//.js_scrollPoint 2つめ（area-2）以上.js_scrollPoint 3つめ（area-3）未満
    $(NavElem[2]).addClass('is_current');//3つめのliに現在地クラスを付与
  }
  else if (scroll >= elemTop[3]) {// .js_scrollPoint 3つめ（area-3）以上
    $(NavElem[3]).addClass('is_current');//4つめのliに現在地クラスを付与
  }
}

// ページ内リンク
$(window).on('load scroll', () => {
  const headerHeight = $('header').outerHeight() + 40;
  $('.js_scroll_pagelink a[href^="#"]').click(function () {
    const href = $(this).attr('href');
    const target = $(href === '#' || href === '' ? 'html' : href);
    const position = target.offset().top - headerHeight;
    $('body,html').stop().animate({ scrollTop: position }, 500);
    return false;
  });
});

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
  PositionCheck();/* 現在地を取得する関数を呼ぶ*/
  ScrollAnime();/* ナビゲーションに現在地のクラスをつけるための関数を呼ぶ*/
});

// ページが読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
  PositionCheck();/* 現在地を取得する関数を呼ぶ*/
  ScrollAnime();/* ナビゲーションに現在地のクラスをつけるための関数を呼ぶ*/
});

$(window).resize(function () {
  //リサイズされたときの処理
  PositionCheck()
});
